(() => {
  const root = document.querySelector('[data-whispers-calendar]');
  if (!root) return;

  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const productCatalog = {
    custom: {
      handle: 'customizable-protection-spell',
      title: 'Custom Spell',
      image: 'https://cdn.shopify.com/s/files/1/0982/2991/1883/files/ChatGPT_Image_4_sept._2026_15_12_17.png?v=1788544431'
    },
    vitality: {
      handle: 'health-well-being-personalized-spiritual-ritual',
      title: 'Health & Well-being Ritual',
      image: 'https://cdn.shopify.com/s/files/1/0982/2991/1883/files/ChatGPT_Image_4_sept._2026_14_36_31_2.png?v=1788544430'
    },
    love: {
      handle: 'love-relationship-personalized-slavic-ritual',
      title: 'Love & Relationship Ritual',
      image: 'https://cdn.shopify.com/s/files/1/0982/2991/1883/files/ChatGPT_Image_4_sept._2026_14_36_30_1.png?v=1788544430'
    },
    luck: {
      handle: 'luck-and-opportunities-spell',
      title: 'Luck & Opportunities Ritual',
      image: 'https://cdn.shopify.com/s/files/1/0982/2991/1883/files/ChatGPT_Image_4_sept._2026_14_36_32_5.png?v=1788544265'
    },
    sleep: {
      handle: 'nightmares-dark-entities-personalized-protection-ritual',
      title: 'Nightmares & Dark Entities Ritual',
      image: 'https://cdn.shopify.com/s/files/1/0982/2991/1883/files/ChatGPT_Image_4_sept._2026_14_36_34_10.png?v=1788544430'
    },
    prosperity: {
      handle: 'prosperity-finances-personalized-slavic-ritual',
      title: 'Prosperity & Finances Ritual',
      image: 'https://cdn.shopify.com/s/files/1/0982/2991/1883/files/ChatGPT_Image_4_sept._2026_14_36_32_6.png?v=1788544431'
    },
    protection: {
      handle: 'protection-energy-ritual',
      title: 'Protection & Energy Ritual',
      image: 'https://cdn.shopify.com/s/files/1/0982/2991/1883/files/ChatGPT_Image_4_sept._2026_14_36_33_8.png?v=1788544430'
    },
    communication: {
      handle: 'relations-harmony-personalized-communication-ritual',
      title: 'Relations & Harmony Ritual',
      image: 'https://cdn.shopify.com/s/files/1/0982/2991/1883/files/ChatGPT_Image_4_sept._2026_14_36_32_4.png?v=1788544430'
    },
    release: {
      handle: 'release-and-transformation-ritual',
      title: 'Release & Transformation Ritual',
      image: 'https://cdn.shopify.com/s/files/1/0982/2991/1883/files/ChatGPT_Image_4_sept._2026_14_36_33_9.png?v=1788544431'
    },
    tarot: {
      handle: 'personalized-slavic-tarot-reading',
      title: 'Personalized Tarot Reading',
      image: 'https://cdn.shopify.com/s/files/1/0982/2991/1883/files/ChatGPT_Image_4_sept._2026_15_12_49_1.png?v=1788544430'
    },
    intuition: {
      handle: 'spiritual-awakening-ritual',
      title: 'Spiritual Awakening Ritual',
      image: 'https://cdn.shopify.com/s/files/1/0982/2991/1883/files/ChatGPT_Image_4_sept._2026_14_36_33_7.png?v=1788544430'
    },
    success: {
      handle: 'success-achievement-ritual',
      title: 'Success & Achievement Ritual',
      image: 'https://cdn.shopify.com/s/files/1/0982/2991/1883/files/ChatGPT_Image_4_sept._2026_14_36_31_3.png?v=1788544430'
    },
    booster: {
      handle: 'spell-booster',
      title: 'Spell Booster',
      image: 'https://cdn.shopify.com/s/files/1/0982/2991/1883/files/ChatGPT_Image_4_sept._2026_19_58_35.png?v=1788544725'
    }
  };

  // Liquid supplies current Shopify prices without a client-side catalogue request.
  // Missing/unavailable products never fall back to stale, hard-coded amounts.
  let productPrices = {};
  try { productPrices = JSON.parse(root.querySelector('[data-calendar-product-prices]')?.textContent || '{}') || {}; } catch (_) { /* Links remain usable without prices. */ }
  Object.values(productCatalog).forEach((product) => {
    const entry = productPrices[product.handle];
    product.price = entry?.available === true && typeof entry.price === 'string' ? entry.price.trim() : '';
  });

  const weekdayGuides = [
    {
      name: 'Sunday · solar clarity',
      intro: 'Sunday traditionally carries a solar quality: visibility, warmth, confidence and the wish to move with purpose.',
      understand: 'Notice where you are ready to be seen without making yourself smaller.',
      practice: 'Stand in daylight for a few quiet minutes and name one result you are willing to work toward.',
      prompt: 'What would I do today if I trusted my own light?',
      products: [['success', 'For confidence and forward movement'], ['vitality', 'For renewed energy']]
    },
    {
      name: 'Monday · lunar listening',
      intro: 'Monday is associated with the Moon: emotion, memory, intuition, home and the rhythms that help us feel safe.',
      understand: 'Let your inner state become information rather than something to judge.',
      practice: 'Place a glass of water beside you, breathe slowly and identify the feeling beneath the noise.',
      prompt: 'What does my inner world need from me today?',
      products: [['intuition', 'For deeper inner listening'], ['vitality', 'For gentle restoration']]
    },
    {
      name: 'Tuesday · courageous action',
      intro: 'Tuesday carries an active, decisive current. It favours boundaries, courage and one honest step through resistance.',
      understand: 'Courage can be quiet: a clear no, a first attempt or a conversation you stop avoiding.',
      practice: 'Write one action small enough to complete today, then begin before you feel perfectly ready.',
      prompt: 'Where would one brave step change the atmosphere?',
      products: [['protection', 'For steadier boundaries'], ['success', 'For focused action']]
    },
    {
      name: 'Wednesday · words and pathways',
      intro: 'Wednesday favours language, learning, exchange and the small choices that redirect a path.',
      understand: 'Words create openings when they are specific, timely and true.',
      practice: 'Rewrite one wish as a clear request or practical next step.',
      prompt: 'What needs to be said more simply?',
      products: [['communication', 'For clearer dialogue'], ['tarot', 'For perspective at a crossroads']]
    },
    {
      name: 'Thursday · growth and opportunity',
      intro: 'Thursday is a day of expansion: opportunity, generosity, learning and the structures that let good fortune grow.',
      understand: 'Expansion becomes sustainable when it has a direction and room to take root.',
      practice: 'Choose one resource you can cultivate: a skill, relationship, saving habit or useful introduction.',
      prompt: 'What would healthy growth look like this month?',
      products: [['luck', 'For opening new possibilities'], ['prosperity', 'For long-term abundance']]
    },
    {
      name: 'Friday · affection and harmony',
      intro: 'Friday carries themes of love, beauty, reconciliation and the art of receiving what is nourishing.',
      understand: 'Harmony is not silence; it is honest connection with enough softness to keep listening.',
      practice: 'Offer one sincere gesture of care to yourself, a loved one or the space around you.',
      prompt: 'What kind of love am I ready to practice, not merely request?',
      products: [['love', 'For strengthening emotional bonds'], ['communication', 'For restoring dialogue']]
    },
    {
      name: 'Saturday · boundaries and release',
      intro: 'Saturday invites simplification, protection and the mature work of releasing what has reached its limit.',
      understand: 'A boundary is a structure that protects what deserves to continue.',
      practice: 'Clear one physical corner, close one unfinished loop or write down what you no longer need to carry.',
      prompt: 'What becomes possible when I stop feeding what drains me?',
      products: [['release', 'For letting go of the past'], ['protection', 'For reinforcing boundaries']]
    }
  ];

  const moonGuides = [
    {
      name: 'New Moon', glyph: '●', range: [0, 1.8],
      intro: 'The Moon is dark or nearly dark. Symbolically, this is a quiet threshold for choosing a seed before demanding visible results.',
      understand: 'Beginnings need clarity more than intensity.',
      practice: 'Write one intention in present, practical language and choose the first supporting action.',
      prompt: 'What do I want to begin with patience?',
      products: [['luck', 'For opening a new path'], ['custom', 'For a highly personal intention']]
    },
    {
      name: 'Waxing Crescent', glyph: '◔', range: [1.8, 5.5],
      intro: 'A thin crescent appears. This phase is traditionally associated with commitment, trust and protecting a new beginning.',
      understand: 'Early progress is often delicate and easy to overlook.',
      practice: 'Give your intention ten undistracted minutes today.',
      prompt: 'What small sign would show that I am moving?',
      products: [['luck', 'For momentum and opportunity'], ['success', 'For supporting the first steps']]
    },
    {
      name: 'First Quarter', glyph: '◐', range: [5.5, 9.2],
      intro: 'Half the Moon is illuminated. This is a symbolic point of choice, effort and adjustment.',
      understand: 'Friction can reveal the next useful decision.',
      practice: 'Name the obstacle, then separate what you can influence from what you cannot.',
      prompt: 'Which decision would restore momentum?',
      products: [['success', 'For determination and progress'], ['booster', 'For strengthening an existing working']]
    },
    {
      name: 'Waxing Gibbous', glyph: '◕', range: [9.2, 12.9],
      intro: 'The light is building. This phase supports refinement, preparation and patient improvement.',
      understand: 'Not every adjustment is a setback; some are signs of skill.',
      practice: 'Improve one detail instead of starting over.',
      prompt: 'What deserves refinement before completion?',
      products: [['success', 'For finishing with focus'], ['communication', 'For useful feedback and clarity']]
    },
    {
      name: 'Full Moon', glyph: '○', range: [12.9, 16.6],
      intro: 'The lunar cycle reaches maximum visibility. Traditionally, this is a time for illumination, gratitude and honest recognition.',
      understand: 'What is visible can be celebrated, understood or consciously released.',
      practice: 'List what has become clear since the last New Moon. Thank what helped you reach this point.',
      prompt: 'What truth is now too visible to ignore?',
      products: [['intuition', 'For insight and spiritual awareness'], ['tarot', 'For reflective guidance']]
    },
    {
      name: 'Waning Gibbous', glyph: '◕', range: [16.6, 20.3],
      intro: 'The light begins to soften. This phase is linked with integration, gratitude and sharing what has been learned.',
      understand: 'Wisdom grows when experience is digested rather than rushed past.',
      practice: 'Write down one lesson and one way to apply it differently next time.',
      prompt: 'What lesson is ready to become a habit?',
      products: [['tarot', 'For integrating recent lessons'], ['vitality', 'For restorative care']]
    },
    {
      name: 'Last Quarter', glyph: '◑', range: [20.3, 24.0],
      intro: 'Half the Moon remains visible. Symbolically, this is a turning point for release, forgiveness and course correction.',
      understand: 'Letting go is a form of direction.',
      practice: 'Choose one pattern, object or obligation to reduce today.',
      prompt: 'What am I maintaining only because it is familiar?',
      products: [['release', 'For a conscious ending'], ['protection', 'For clearer boundaries']]
    },
    {
      name: 'Waning Crescent', glyph: '◔', range: [24.0, 29.6],
      intro: 'The cycle grows quiet again. This phase favours rest, cleansing, dreams and creating space for what comes next.',
      understand: 'Rest is part of the ritual, not an interruption to it.',
      practice: 'Lower stimulation for one hour and make your evening deliberately simple.',
      prompt: 'What can wait while I restore myself?',
      products: [['sleep', 'For calmer nights and energetic protection'], ['release', 'For clearing residual weight']]
    }
  ];

  const traditions = [
    {
      month: 0, day: 6, title: 'Kolyada · Winter threshold', type: 'tradition',
      summary: 'Kolyada names a family of midwinter customs found across parts of the Slavic world. Songs, masked processions, shared food and household blessings celebrate endurance and the returning Sun.',
      meaning: 'This threshold places renewal inside the community. Warmth, luck and protection are strengthened through generosity, hospitality and shared remembrance.',
      correspondences: 'Sun symbols, evergreen, grain, bells, candles, gold, red and gifts of food.',
      practice: 'Light a candle at dusk, offer gratitude for the people who carried you through the dark season, then name one quality you want to keep alive until spring.',
      prompt: 'What warmth can I offer as the cycle begins again?',
      products: [['protection', 'For blessing and protecting the home'], ['vitality', 'For returning energy']]
    },
    {
      month: 1, day: 2, title: 'Gromnica · Candle blessing', type: 'tradition',
      summary: 'Gromnica is associated with blessed candles, winter storms and household protection in several Slavic and Central European traditions. It stands at the first visible turn toward spring.',
      meaning: 'The guarded flame represents continuity, vigilance and care. It reminds us that protection can be calm, practical and sustained.',
      correspondences: 'Beeswax candles, linen, salt, white and gold, thresholds, hearth and home.',
      practice: 'Light one candle safely and walk through your space slowly, noticing where calm, order or repair is needed.',
      prompt: 'What helps my home feel protected and peaceful?',
      products: [['protection', 'For household and energetic protection'], ['sleep', 'For peaceful nights']]
    },
    {
      month: 2, day: 22, title: 'Zhavoronki · Calling spring', type: 'tradition',
      summary: 'Zhavoronki, or Lark Day, is a spring folk observance in parts of Eastern Europe. Bird-shaped breads, songs and gestures of welcome call the season back into motion.',
      meaning: 'The day teaches active hope: we prepare for renewal before the landscape is fully transformed.',
      correspondences: 'Birds, seeds, bread, open windows, sky blue, young green and morning air.',
      practice: 'Open a window, refresh one part of your home and make a visible sign of the season you want to welcome.',
      prompt: 'What am I ready to call back into motion?',
      products: [['luck', 'For fresh opportunities'], ['vitality', 'For renewed energy']]
    },
    {
      month: 3, day: 30, title: 'Walpurgis Night · Witches’ night', type: 'tradition',
      summary: 'Walpurgis Night is observed across parts of Central and Northern Europe on the eve of May. Modern witchcraft often treats it as a night of fire, protection and the lively crossing into summer.',
      meaning: 'The night combines celebration with strong boundaries. It is a time to clear what feels stagnant before welcoming growth, desire and movement.',
      correspondences: 'Bonfires, bells, rowan, birch, protective herbs, red, black and bright flame.',
      practice: 'Sweep your threshold, light a safe candle and name what may enter your next season and what must remain outside it.',
      prompt: 'Which boundary will let my energy grow more freely?',
      products: [['protection', 'For clear energetic boundaries'], ['release', 'For clearing stagnant energy']]
    },
    {
      month: 6, day: 6, title: 'Kupala Night · Water and fire', type: 'tradition',
      summary: 'Kupala Night celebrations combine summer, water, fire, herbs, wreaths and courtship motifs. Dates and customs vary by region and by the civil or traditional calendar used.',
      meaning: 'Water and fire express two complementary forms of purification: gentle release and courageous transformation. The night also honours vitality, attraction and the wild abundance of summer.',
      correspondences: 'River water, fire, fern, wildflowers, wreaths, white cloth, red ribbons and summer herbs.',
      practice: 'Place a bowl of water beside a candle. Name what you wish to cool, then what you are ready to energize.',
      prompt: 'What needs gentleness, and what needs courage?',
      products: [['love', 'For warmth and emotional connection'], ['vitality', 'For summer energy']]
    },
    {
      month: 7, day: 14, title: 'Honey Spas · First harvest', type: 'tradition',
      summary: 'Honey Spas begins a sequence of August harvest observances in parts of Eastern Europe. The first honey, water and poppy traditions create a moment of sweetness, blessing and gratitude.',
      meaning: 'The first harvest asks us to recognize results before immediately chasing the next goal.',
      correspondences: 'Honey, bees, poppy, water, amber, gold, bread and offerings of sweetness.',
      practice: 'Taste something sweet with full attention and write down three forms of abundance already present.',
      prompt: 'What has quietly ripened in my life?',
      products: [['prosperity', 'For abundance with gratitude'], ['love', 'For sweetness in relationships']]
    },
    {
      month: 7, day: 19, title: 'Apple Spas · Ripening and change', type: 'tradition',
      summary: 'Apple Spas is a late-summer observance associated with blessing fruit, sharing the harvest and noticing the first unmistakable turn toward autumn.',
      meaning: 'Ripeness and change arrive together: receiving the fruit also means accepting the season’s movement.',
      correspondences: 'Apples, fruit trees, honey, harvest baskets, green, red and the five-pointed apple core.',
      practice: 'Cut an apple, notice its star-shaped centre and share part of it as a gesture of reciprocity.',
      prompt: 'What am I ready to receive, and what must change with it?',
      products: [['prosperity', 'For receiving and stewarding abundance'], ['release', 'For accepting seasonal change']]
    },
    {
      month: 9, day: 31, title: 'Veles Night · Modern Slavic-inspired observance', type: 'tradition',
      summary: 'Veles Night is observed in modern Slavic-inspired spirituality as a liminal night of ancestors, dreams and the unseen. It is a contemporary observance rather than one universal historical custom.',
      meaning: 'Its central lesson is respectful remembrance and careful listening at a symbolic threshold, held together with firm spiritual boundaries.',
      correspondences: 'Ancestor photographs, keys, dark cloth, candlelight, earth, wool, bread and quiet divination.',
      practice: 'Place a family-safe object or written name on a clean cloth, light a candle and remember one quality worth carrying forward.',
      prompt: 'Which inherited strength do I choose to continue?',
      products: [['intuition', 'For reflective spiritual listening'], ['protection', 'For firm energetic boundaries']]
    },
    {
      month: 10, day: 1, title: 'Dziady · Ancestral remembrance', type: 'tradition',
      summary: 'Dziady refers to ancestral remembrance customs found in parts of Poland, Belarus, Lithuania and neighbouring regions. Historical practices vary considerably by place, community and period.',
      meaning: 'Hospitality toward memory becomes a mirror for the living. Remembering the dead can clarify the values, stories and strengths we choose to continue.',
      correspondences: 'Candles, bread, honey, water, names, family objects, quiet tables and autumn leaves.',
      practice: 'Write a private note of gratitude to someone who shaped your path. Keep it, burn it safely or place it beneath a candle.',
      prompt: 'What memory still carries useful guidance?',
      products: [['tarot', 'For contemplative guidance'], ['intuition', 'For deeper reflection']]
    }
  ];

  const seasons = [
    {
      month: 1, day: 1, title: 'Imbolc · First light', type: 'season',
      summary: 'Imbolc is a fire and hearth festival placed at the first stirring of spring. In modern witchcraft it marks purification, inspiration and the return of light while winter is still present.',
      meaning: 'Imbolc honours beginnings that are not yet visible. Preparation, cleansing and a protected spark matter more than dramatic action.',
      correspondences: 'Candles, hearth fire, milk, oats, snowdrops, white, pale green, wells and woven crosses.',
      practice: 'Clean one small threshold in your home, light a white candle and dedicate it to one beginning you are ready to tend patiently.',
      prompt: 'What small flame deserves my protection now?',
      products: [['vitality', 'For renewal after winter'], ['protection', 'For blessing the home']]
    },
    {
      month: 2, day: 20, title: 'Ostara · Spring Equinox', type: 'season',
      summary: 'At the Spring Equinox, day and night stand near balance as the Northern Hemisphere moves toward greater light. Modern witches often call this sabbat Ostara.',
      meaning: 'Balance is dynamic, not motionless. The festival asks which hopes are ready to become practical commitments and receive steady care.',
      correspondences: 'Eggs, seeds, hares, spring flowers, dawn, yellow, green, air and fertile soil.',
      practice: 'Plant or hold a seed while naming one beginning you will support with a real weekly action.',
      prompt: 'What is ready to grow because I am ready to tend it?',
      products: [['luck', 'For opening a new season'], ['vitality', 'For renewed energy']]
    },
    {
      month: 4, day: 1, title: 'Beltane · Fire and flourishing', type: 'season',
      summary: 'Beltane opens the bright half of the year in the modern Wheel of the Year. It celebrates vitality, attraction, creativity, pleasure and the flourishing of the living world.',
      meaning: 'Desire becomes sacred when it is joined with consent, care and the willingness to nourish what we invite.',
      correspondences: 'Hawthorn, ribbons, flowers, bonfires, dew, red, white, green and shared feasting.',
      practice: 'Tie a ribbon for one quality you want to welcome, then choose one joyful action that gives it a place to grow.',
      prompt: 'What am I ready to welcome with my whole heart?',
      products: [['love', 'For attraction and loving connection'], ['vitality', 'For creative life force']]
    },
    {
      month: 5, day: 21, title: 'Litha · Summer Solstice', type: 'season',
      summary: 'The Summer Solstice brings the longest day and the solar peak of the Wheel of the Year. Litha celebrates vitality, abundance and the fullness of outward life.',
      meaning: 'The brightest point reveals what has grown and reminds us that every peak begins a gradual turn. Celebration and wise stewardship belong together.',
      correspondences: 'Sunflowers, oak, St John’s wort, honey, fire, gold, green, fresh water and noon sunlight.',
      practice: 'Celebrate one thing you have built, then decide how you will protect its momentum.',
      prompt: 'What deserves to be fully seen and celebrated?',
      products: [['success', 'For recognition and achievement'], ['vitality', 'For strength and well-being']]
    },
    {
      month: 7, day: 1, title: 'Lughnasadh · First harvest', type: 'season',
      summary: 'Lughnasadh, also called Lammas in many modern witchcraft calendars, is the first of three harvest festivals. It honours grain, skill, labour and the first visible results of sustained effort.',
      meaning: 'Harvest includes gratitude and responsibility. We recognise what has ripened, the labour behind it and what must be shared or replanted.',
      correspondences: 'Bread, wheat, corn, berries, sunflowers, gold, bronze, sickles and handmade crafts.',
      practice: 'Share bread or another simple food, then name one skill that helped bring you this far and one way to deepen it.',
      prompt: 'What result am I ready to acknowledge with gratitude?',
      products: [['prosperity', 'For harvest and sustainable abundance'], ['success', 'For honouring skilled work']]
    },
    {
      month: 8, day: 22, title: 'Mabon · Autumn Equinox', type: 'season',
      summary: 'At the Autumn Equinox, light and darkness return to near balance. In many modern witchcraft traditions, Mabon is the second harvest and a festival of gratitude, reciprocity and preparation.',
      meaning: 'Harvest is both celebration and honest accounting. The season asks what grew, what did not and what should be preserved before the darker half of the year.',
      correspondences: 'Apples, grapes, acorns, wine, baskets, amber, burgundy, brown, scales and the setting Sun.',
      practice: 'List three results of your recent effort and one adjustment for the coming season.',
      prompt: 'What am I gathering, and what am I leaving in the field?',
      products: [['prosperity', 'For honouring and extending abundance'], ['release', 'For seasonal letting go']]
    },
    {
      month: 9, day: 31, title: 'Samhain · Ancestors and endings', type: 'season',
      summary: 'Samhain closes the harvest and opens the dark half of the year in the modern Wheel of the Year. It is widely observed as a time for ancestors, endings, divination and the mystery of transition.',
      meaning: 'Samhain teaches that remembrance and release can coexist. It invites honest endings while protecting the wisdom that deserves to continue.',
      correspondences: 'Apples, dark cloth, lanterns, ancestor photographs, rosemary, black, orange, silver and protective fire.',
      practice: 'Create a simple remembrance place with a name, photograph or safe object. Offer gratitude, then write one thing you are ready to release.',
      prompt: 'What must end, and what wisdom will I carry forward?',
      products: [['release', 'For endings and transformation'], ['intuition', 'For ancestral reflection and divination']]
    },
    {
      month: 11, day: 21, title: 'Yule · Winter Solstice', type: 'season',
      summary: 'The Winter Solstice is the longest night and the rebirth of the solar year. Yule celebrates rest, protection, kinship and the first promise of returning light.',
      meaning: 'Hope is not always brightness. Sometimes it is the deliberate choice to keep one flame alive while the world remains dark.',
      correspondences: 'Evergreen, holly, ivy, pine, candles, bells, cinnamon, gold, red, green and the Yule log.',
      practice: 'Dim the room, light one safe candle and name what you will protect until the light grows.',
      prompt: 'What quiet promise will guide me through winter?',
      products: [['protection', 'For shelter and energetic boundaries'], ['sleep', 'For restorative winter rest']]
    }
  ];

  const moonPhases = [
    {
      offset: 0, title: 'New Moon', glyph: '●',
      summary: 'The lunar cycle returns to darkness. Across many contemporary witchcraft practices, the New Moon is a quiet threshold for intention, renewal and work that begins below the surface.',
      meaning: 'The New Moon asks for a clear seed, privacy and patience rather than immediate proof.',
      correspondences: 'Darkness, seeds, still water, black or white candles, cleansing, intention and beginnings.',
      practice: 'Write one focused intention and one action that makes it real.',
      prompt: 'What am I willing to begin without needing applause?',
      products: [['luck', 'For opening a path'], ['custom', 'For a personal intention']]
    },
    {
      offset: 0.25, title: 'First Quarter Moon', glyph: '◐',
      summary: 'The waxing Moon reaches its first quarter, creating a visible half-lit disc. In lunar witchcraft this is a point of action, decision and constructive tension.',
      meaning: 'The intention chosen at the New Moon now meets reality. Resistance can reveal which choice, boundary or practical adjustment is needed.',
      correspondences: 'Waxing light, movement, courage, red and gold, fire, momentum, tools and decisive action.',
      practice: 'Name the main obstacle in one sentence, then complete one concrete action that moves through or around it.',
      prompt: 'Which decision would restore momentum?',
      products: [['success', 'For determined progress'], ['booster', 'For strengthening an existing intention']]
    },
    {
      offset: 0.5, title: 'Full Moon', glyph: '○',
      summary: 'The Moon reaches maximum illumination. In witchcraft, the Full Moon is a major esbat associated with culmination, heightened awareness, celebration, divination and release.',
      meaning: 'What has grown becomes easier to name, celebrate, understand or consciously release.',
      correspondences: 'Moonlight, water, silver, white flowers, crystal, gratitude, divination and culmination.',
      practice: 'Review the past two weeks and write down what is now clear.',
      prompt: 'What truth has reached full visibility?',
      products: [['intuition', 'For insight and spiritual awareness'], ['tarot', 'For reflective guidance']]
    },
    {
      offset: 0.75, title: 'Last Quarter Moon', glyph: '◑',
      summary: 'The waning Moon reaches its last quarter, another half-lit turning point. Witchcraft traditions often connect it with release, cleansing, forgiveness and course correction.',
      meaning: 'This phase asks what no longer deserves energy. A conscious ending creates space for rest and the next lunar cycle.',
      correspondences: 'Waning light, water and earth, sweeping, smoke cleansing, dark blue, grey, release and closure.',
      practice: 'Clear one object, obligation or repeated thought that has completed its purpose, then acknowledge the space it leaves behind.',
      prompt: 'What am I ready to stop maintaining?',
      products: [['release', 'For a conscious ending'], ['protection', 'For restoring clear boundaries']]
    }
  ];

  const zodiac = [
    [0, 20, 'Aquarius Season', 'Vision, independence, community and unconventional thought', 'intuition'],
    [1, 19, 'Pisces Season', 'Dreams, sensitivity, compassion and spiritual listening', 'intuition'],
    [2, 20, 'Aries Season', 'Initiative, courage, desire and direct action', 'success'],
    [3, 20, 'Taurus Season', 'Stability, embodiment, value and material grounding', 'prosperity'],
    [4, 21, 'Gemini Season', 'Communication, curiosity, movement and connection', 'communication'],
    [5, 21, 'Cancer Season', 'Home, ancestry, care and emotional protection', 'protection'],
    [6, 23, 'Leo Season', 'Confidence, creativity, pleasure and visibility', 'success'],
    [7, 23, 'Virgo Season', 'Discernment, craft, order and practical healing', 'vitality'],
    [8, 23, 'Libra Season', 'Balance, partnership, beauty and reciprocity', 'love'],
    [9, 23, 'Scorpio Season', 'Truth, intimacy, shadow work and transformation', 'release'],
    [10, 22, 'Sagittarius Season', 'Expansion, wisdom, travel and opportunity', 'luck'],
    [11, 21, 'Capricorn Season', 'Discipline, ambition, structure and lasting work', 'success']
  ];

  const researchSources = {
    moon: ['NASA · Moon Phases', 'https://science.nasa.gov/moon/moon-phases/'],
    eclipses: ['NASA · Eclipses', 'https://science.nasa.gov/eclipses/'],
    eclipseSafety: ['NASA · Eclipse Safety', 'https://science.nasa.gov/eclipses/safety/'],
    blueMoon: ['NASA · Super Blue Moons explained', 'https://science.nasa.gov/solar-system/moon/super-blue-moons-your-questions-answered/'],
    wheel: ['World History Encyclopedia · Wheel of the Year', 'https://www.worldhistory.org/Wheel_of_the_Year/'],
    seasons: ['Met Office · Equinoxes and solstices', 'https://weather.metoffice.gov.uk/learn-about/weather/seasons/equinox-and-solstice'],
    stonehenge: ['English Heritage · Solstice at Stonehenge', 'https://www.english-heritage.org.uk/visit/places/stonehenge/things-to-do/solstice'],
    walpurgis: ['World History Encyclopedia · Walpurgis Night', 'https://www.worldhistory.org/Walpurgis_Night/'],
    kupala: ['Culture.pl · Kupala Night', 'https://culture.pl/en/article/kupala-night-mixing-pagan-christian-traditions'],
    dziady: ['Culture.pl · Forefathers’ Eve', 'https://culture.pl/en/work/forefathers-eve-adam-mickiewicz'],
    dziadyStudy: ['University of Warsaw · Calendar rituals of ancestor veneration', 'https://albaruthenica.uw.edu.pl/en/issues/issue-18/the-calendar-rituals-of-ancestor-veneration-in-the-traditional-culture-of-belarusians-research-problems-and-perspectives'],
    gromnica: ['Ethnographic Museum in Rzeszów · Gromnica', 'https://muzeumetnograficzne.rzeszow.pl/2025/01/29/2-luty-matki-boskiej-gromnicznej/'],
    kolyada: ['Etar Museum · Carol-singing traditions', 'https://en.etar.bg/carol-singing-school'],
    ukrainianChristmas: ['Ukraïner · Ukrainian Christmas traditions', 'https://www.ukrainer.net/en/ukrainian-christmas-traditions-food-carols-and-nativity-scenes/'],
    zhavoronki: ['Ethnographic research · Spring ritual baking', 'https://cyberleninka.ru/article/n/vesennee-obryadovoe-pechenie-v-kalendarnoy-obryadnosti-russkih-srednego-povolzhya'],
    honeySpas: ['National Museum of Folk Architecture · Makovii and Honey Spas', 'https://uatv.ua/en/makovii-traditional-christian-honey-celebration/'],
    appleSpas: ['Apple Feast of the Saviour · overview', 'https://en.wikipedia.org/wiki/Apple_Feast_of_the_Saviour'],
    slavicFaith: ['Cambridge University Press · Slavic Native Faith', 'https://www.cambridge.org/core/services/aop-cambridge-core/content/view/C6AC26C0A15F84A0D7D8243B60C362F7/9781009539593AR.pdf/slavic_native_faith.pdf'],
    zodiacOxford: ['History of Science Museum, Oxford · Signs of the Zodiac', 'https://www.hsm.ox.ac.uk/signs-zodiac'],
    zodiacBerlin: ['Freie Universität Berlin · The Zodiac', 'https://www.geschkult.fu-berlin.de/en/e/zodiac/_inhaltselemente/homepage.html']
  };

  const researchProfiles = {
    'new-moon': {
      history: `Astronomically, the New Moon occurs when the Moon is positioned near the Sun in our sky, so its illuminated half faces away from Earth. It is normally invisible in the Sun's glare and begins a synodic cycle of about 29.5 days.`,
      tradition: `Contemporary lunar spirituality often treats this dark interval as a private beginning rather than a spectacle. The historical and cultural meanings of lunar phases vary, so the reflective practice below is intentionally simple and non-denominational.`,
      steps: ['Dim the room and take five slow breaths.', 'Write one intention in precise, present-tense language.', 'Choose one practical action you can complete within 48 hours.', 'Keep the note private until the First Quarter.'],
      note: `The phase is an astronomical event; intention-setting is a modern symbolic practice, not a scientifically demonstrated lunar effect.`,
      sources: [researchSources.moon]
    },
    'first-quarter-moon': {
      history: `At First Quarter the Moon has completed roughly one quarter of its orbit since New Moon. From Earth, half of the visible disc is illuminated, even though the name refers to orbital progress rather than the fraction of the Moon that is lit.`,
      tradition: `Modern lunar calendars associate the waxing half-moon with decision and effort: the initial intention meets friction and must become a plan. This is a useful checkpoint for evaluating progress without treating the sky as a command.`,
      steps: ['Re-read the intention made at New Moon.', 'Name the clearest obstacle without judging it.', 'Choose whether to persist, adapt or stop.', 'Complete one measurable action today.'],
      note: `Exact local dates can shift with time zone; the calendar uses astronomical calculations and displays the civil date.`,
      sources: [researchSources.moon]
    },
    'full-moon': {
      history: `The Full Moon occurs when Earth lies approximately between the Sun and Moon, allowing the lunar face toward us to appear fully illuminated. It rises around sunset and sets around sunrise, making it the cycle's most visible phase.`,
      tradition: `Many contemporary practitioners use the Full Moon as an esbat for gathering, gratitude, divination and release. Customs are diverse and should not be presented as one universal ancient tradition.`,
      steps: ['Review what changed since the previous New Moon.', 'Record one result, one insight and one unfinished matter.', 'Express gratitude for a person or resource that supported you.', 'Release one expectation that no longer serves the work.'],
      note: `A Full Moon is astronomically exact at one moment, although it appears full to the eye across more than one night.`,
      sources: [researchSources.moon]
    },
    'last-quarter-moon': {
      history: `Last Quarter arrives about three weeks after New Moon. Half the visible lunar disc is illuminated again, now during the waning half of the cycle, and the Moon rises around midnight.`,
      tradition: `In modern ritual calendars this phase is commonly used for editing, forgiveness, clearing and closing tasks. Its value is reflective: it offers a recurring structure for deciding what no longer deserves attention.`,
      steps: ['List what is complete, stalled and still essential.', 'Remove one unnecessary obligation or object.', 'Repair one boundary that has become unclear.', 'Plan a quieter pace before the next New Moon.'],
      note: `Lunar symbolism is interpretive; use it as a planning rhythm rather than a substitute for evidence-based decisions.`,
      sources: [researchSources.moon]
    },
    'blue-moon': {
      history: `In its most common modern usage, a Blue Moon is the second Full Moon in one calendar month. The label depends on the civil calendar and does not mean the Moon changes colour; another older definition names the third Full Moon in a season containing four.`,
      tradition: `Because it is an occasional calendar pattern, contemporary practice often frames it as a moment to revisit an exceptional opportunity or long-held aim. The rarity is calendrical, not evidence of extra physical influence.`,
      steps: ['Identify one opportunity that truly is time-sensitive.', 'Separate excitement from verifiable facts.', 'Ask what support and cost the opportunity requires.', 'Make one deliberate decision rather than several impulsive promises.'],
      note: `“Blue Moon” is a popular calendrical term, not a distinct astronomical phase.`,
      sources: [researchSources.blueMoon, researchSources.moon]
    },
    'black-moon': {
      history: `“Black Moon” is an informal modern label, often used for the second New Moon in a calendar month. Like “Blue Moon,” it is created by the mismatch between the 29.5-day lunar cycle and our calendar months, and definitions can vary.`,
      tradition: `Modern spiritual writers often interpret it as an especially inward reset. A careful approach is to use the date for silence, review and privacy rather than claiming an ancient or universal observance.`,
      steps: ['Turn off nonessential notifications for one hour.', 'Write what you are no longer willing to repeat.', 'Choose one protected intention and its first small action.', 'Wait overnight before announcing a major decision.'],
      note: `The term has no single scientific definition and its spiritual meanings are contemporary.`,
      sources: [researchSources.moon, researchSources.blueMoon]
    },
    'lunar-eclipse': {
      history: `A Lunar Eclipse occurs at Full Moon when the Moon passes through Earth's shadow. Depending on the alignment it can be penumbral, partial or total; during totality, filtered sunlight can give the Moon a copper-red appearance.`,
      tradition: `Eclipses have carried many different meanings across cultures. Contemporary ritual practice often emphasizes observation, grounding and revelation, but no single interpretation should be attributed to all peoples or periods.`,
      steps: ['Confirm the eclipse time and visibility for your location.', 'Observe from a safe, comfortable place; lunar eclipses are safe to view directly.', 'Record facts and feelings separately.', 'Delay irreversible decisions until the heightened moment has passed.'],
      note: `A Lunar Eclipse is safe to watch with the unaided eye; visibility depends on location and weather.`,
      sources: [researchSources.eclipses]
    },
    'solar-eclipse': {
      history: `A Solar Eclipse occurs at New Moon when the Moon passes between Earth and the Sun and casts a shadow on Earth. Total, annular and partial eclipses depend on geometry and the observer's location.`,
      tradition: `Modern ritual calendars often frame an eclipse as interruption, redirection or a threshold whose meaning unfolds slowly. The most important observance is physical safety: never improvise eye protection.`,
      steps: ['Check whether the eclipse is visible where you are.', 'Use certified eclipse glasses or an indirect projector for every partial phase.', 'Keep any reflection quiet and observational.', 'Write what changed in your perspective after the event.'],
      note: `Except during the brief total phase of a total solar eclipse, looking at the Sun without proper protection can cause severe eye injury. Ordinary sunglasses are not safe.`,
      sources: [researchSources.eclipses, researchSources.eclipseSafety]
    },
    'imbolc': {
      history: `Imbolc is a Gaelic seasonal festival associated with the beginning of spring and, in Ireland, with Brigid. Its historical customs developed regionally; the fixed eight-festival “Wheel of the Year” used by many witches is a modern twentieth-century synthesis.`,
      tradition: `Modern observances emphasize hearth, purification, wells, candles and the first subtle signs of growth. Brigid's crosses and domestic preparation may be meaningful, but they should be approached as living cultural forms rather than generic decoration.`,
      steps: ['Clean one doorway, hearth or work surface.', 'Light a candle safely and name what you will tend.', 'Notice one real sign of seasonal change outdoors.', 'Plan the first practical step of a spring project.'],
      note: `Names, dates and customs differ across Irish tradition, modern Pagan paths and local climates.`,
      sources: [researchSources.wheel]
    },
    'ostara': {
      history: `The March Equinox is the astronomical moment when the Sun crosses the celestial equator northward. Day and night are close to equal, though not exactly twelve hours everywhere. “Ostara” as a modern sabbat name belongs to the contemporary Wheel of the Year.`,
      tradition: `Contemporary practice combines seasonal observation with symbols of germination, balance and renewed activity. Historical claims about a single ancient universal equinox festival should be treated cautiously.`,
      steps: ['Check the exact equinox date shown by the calendar.', 'Spend ten minutes observing light, weather and new growth.', 'Plant a seed or begin a modest project.', 'Pair the beginning with a weekly care commitment.'],
      note: `The equinox is astronomical; modern Ostara symbolism varies between traditions.`,
      sources: [researchSources.seasons, researchSources.wheel]
    },
    'beltane': {
      history: `Beltane is a Gaelic May festival marking the beginning of summer, historically associated with pastoral protection and seasonal fire. Modern Pagan and witchcraft traditions place it on the Wheel of the Year as a celebration of vitality and flourishing.`,
      tradition: `Bonfires, flowers, greenery and communal celebration are common modern motifs. Practices involving relationships or fertility are best framed through consent, inclusivity and the broader creativity of living systems.`,
      steps: ['Decorate a small space with local, responsibly gathered greenery.', 'Name what you want to welcome into fuller life.', 'Choose one joyful action that nourishes it.', 'Share food or appreciation with someone who supports your growth.'],
      note: `Beltane customs are not identical across historical Gaelic communities and modern Pagan paths.`,
      sources: [researchSources.wheel]
    },
    'litha': {
      history: `The June Solstice is the moment the Northern Hemisphere reaches its greatest tilt toward the Sun, producing the longest daylight period of the year. “Litha” is widely used for the Summer Solstice in modern Pagan calendars.`,
      tradition: `Fire, flowers, water, feasting and outdoor gatherings express the season's abundance. Solstice monuments such as Stonehenge also remind us that ancient relationships with the Sun were place-specific and cannot be reduced to one modern ritual.`,
      steps: ['Watch sunrise or sunset without looking directly at the Sun.', 'Name one achievement that deserves celebration.', 'Thank the people and materials that made it possible.', 'Decide how you will protect its value as the light begins to turn.'],
      note: `Solstice timing is astronomical and can fall on different civil dates depending on year and time zone.`,
      sources: [researchSources.seasons, researchSources.stonehenge]
    },
    'lughnasadh': {
      history: `Lughnasadh is a Gaelic festival associated with the beginning of harvest and the figure Lugh. Fairs, assemblies, contests and first-fruit themes appear in historical accounts; “Lammas” has a distinct Christian English history centred on loaf-mass.`,
      tradition: `Modern Wheel-of-the-Year practice often centres bread, grain, craft and the first visible results of labour. Treating harvest as both gratitude and responsibility keeps the observance grounded.`,
      steps: ['Prepare or share a simple grain-based food.', 'Name the labour—your own and others’—behind one result.', 'Offer or donate part of what you can share.', 'Choose one skill to refine before the next harvest marker.'],
      note: `Lughnasadh and Lammas overlap in modern practice but are not historically interchangeable in every detail.`,
      sources: [researchSources.wheel]
    },
    'mabon': {
      history: `The September Equinox occurs when the Sun crosses the celestial equator southward. “Mabon” is a modern name for the Autumn Equinox sabbat, popularized within twentieth-century Pagan practice rather than inherited as the name of one ancient festival.`,
      tradition: `Modern observances emphasize harvest accounting, gratitude, reciprocity and preparation for diminishing light. Apples, grapes and stored foods reflect local autumn harvests rather than universal requirements.`,
      steps: ['List what your recent effort actually produced.', 'Thank one person or system that supported the result.', 'Preserve, repair or store something for the darker season.', 'Release one plan that no longer fits the evidence.'],
      note: `Use locally meaningful seasonal signs; September is spring, not autumn, in the Southern Hemisphere.`,
      sources: [researchSources.seasons, researchSources.wheel]
    },
    'samhain': {
      history: `Samhain is a Gaelic festival associated with the transition into winter. Modern Paganism places it at the close of the harvest and often connects it with ancestors and divination; its relationship with later Halloween customs is complex rather than a single direct line.`,
      tradition: `Contemporary observances may include remembrance tables, seasonal meals, candles and divination. The most respectful practice distinguishes family remembrance from borrowed claims about cultures or ancestors one does not belong to.`,
      steps: ['Create a clean, simple place of remembrance.', 'Name a person, creature or chapter you wish to honour.', 'Offer gratitude without demanding a sign or message.', 'Write one ending you accept and one value you carry forward.'],
      note: `Customs vary widely across Gaelic history, folklore, Christianity, Halloween and modern Pagan traditions.`,
      sources: [researchSources.wheel]
    },
    'yule': {
      history: `The December Solstice is the Northern Hemisphere's shortest daylight period and longest night. Yule has Germanic and Norse historical associations, while the eight-sabbat Wheel links it to the symbolic return of solar light.`,
      tradition: `Evergreen, fire, feasting, gifts and community express endurance in the dark season. Many familiar winter customs have layered histories, so the calendar presents them as evolving traditions rather than a single unchanged rite.`,
      steps: ['Mark sunset and reduce unnecessary light for a few minutes.', 'Light one candle safely as a symbol of continuity.', 'Share food, warmth or practical help.', 'Choose one promise small enough to keep through winter.'],
      note: `Seasonal symbolism should be adapted for hemisphere, climate and personal tradition.`,
      sources: [researchSources.seasons, researchSources.wheel]
    },
    'kolyada': {
      history: `Kolyada refers to a family of winter customs across Slavic regions rather than one identical festival. House-to-house carolling, costumes, ritual greetings and gifts became layered with Christian Christmas calendars and local folk practice.`,
      tradition: `Groups may sing blessings for a household and receive food or small gifts in return. The exchange links abundance to hospitality: good wishes move through the community rather than remaining private.`,
      steps: ['Learn one regional carol or family winter song.', 'Light a candle and offer a spoken blessing for the household.', 'Share food or make a charitable gift.', 'Record which customs belong to your own family or region.'],
      note: `Dates differ between countries and between Julian, revised Julian and Gregorian church calendars.`,
      sources: [researchSources.kolyada, researchSources.ukrainianChristmas]
    },
    'gromnica': {
      history: `Gromnica is linked with the Feast of the Presentation on 2 February in Polish and neighbouring traditions. A blessed beeswax candle—also called a gromnica—was kept in the home and lit during storms, illness, danger and at the bedside of the dying.`,
      tradition: `The candle gathers Christian devotion, household protection and weather folklore into one material object. Museum sources emphasize that exact practices and markings varied by region and family.`,
      steps: ['Place a stable candle in a fire-safe holder.', 'Check smoke alarms and practical household safety first.', 'Light the candle briefly while naming what protection means in action.', 'Extinguish it carefully and store it respectfully.'],
      note: `This is a living Catholic folk tradition; do not detach the object from its devotional context when claiming historical authenticity.`,
      sources: [researchSources.gromnica]
    },
    'zhavoronki': {
      history: `Zhavoronki (“larks”) names springtime customs in parts of Eastern Europe in which bird-shaped breads and songs welcome migrating birds and warmer weather. Dates and meanings differ, sometimes joining folk weather lore with the Christian feast of the Forty Martyrs.`,
      tradition: `Children may carry baked birds, sing calls to spring or place them high where the “larks” can meet the sky. The core motif is participatory hope: people prepare for renewal before the landscape is fully changed.`,
      steps: ['Observe which birds are actually present in your area.', 'Bake or shape a simple bird from bread or clay.', 'Open a window and refresh one neglected space.', 'Name one action that helps spring become tangible in your life.'],
      note: `Treat “Slavic tradition” as regionally diverse; spelling, date and custom vary among communities.`,
      sources: [researchSources.zhavoronki]
    },
    'walpurgis': {
      history: `Walpurgis Night is observed on 30 April across parts of Central and Northern Europe. Its name is connected to Saint Walpurga, while later folklore, literature and modern witchcraft layered the night with bonfires, witches, noise-making and protection.`,
      tradition: `Regional celebrations range from communal fires and seasonal festivities to theatrical “witches’ night” imagery. The history is a mixture of Christian feast, local folklore and later cultural reinvention.`,
      steps: ['Sweep or clean the physical threshold of your home.', 'Light a contained candle or outdoor fire only where legal and safe.', 'Write what is welcome and what is not.', 'Celebrate the approach of summer with music or shared food.'],
      note: `Avoid presenting modern occult imagery as a single unchanged pre-Christian ceremony.`,
      sources: [researchSources.walpurgis]
    },
    'kupala': {
      history: `Kupala Night is a midsummer celebration found in several Eastern European cultures, commonly combining water, fire, herbs, wreaths, courtship and later Christian associations with John the Baptist. The date varies with region and calendar.`,
      tradition: `Bonfire jumping, wreath floating and the legendary search for a fern flower are widely recognized motifs. Public celebrations today may be folkloric, religious, revived or newly reconstructed.`,
      steps: ['Choose a water-safe, biodegradable flower offering—or keep it on land.', 'Place a bowl of water beside a safely contained candle.', 'Name what needs cooling and what needs courage.', 'Celebrate with music or movement without risking fire or waterways.'],
      note: `Never leave candles or fires unattended, and do not release ribbons, wire or plastic into rivers.`,
      sources: [researchSources.kupala]
    },
    'honey-spas': {
      history: `Honey Spas, often associated with Makovii on 14 August, begins a sequence of late-summer “Saviour” observances in Ukrainian and neighbouring traditions. Honey, poppy, herbs and water appear alongside Orthodox Christian blessing practices.`,
      tradition: `Seasonal produce is brought for blessing, shared and preserved. The sweetness is not merely decorative: it marks agricultural labour, pollination, community and gratitude at the first harvest threshold.`,
      steps: ['Learn where your honey was produced and by whom.', 'Taste a small amount slowly or use a non-honey local alternative.', 'Thank the human and more-than-human labour behind the harvest.', 'Share food or support a pollinator-friendly project.'],
      note: `People with allergies, infants under one year and those avoiding animal products should choose a safe alternative.`,
      sources: [researchSources.honeySpas]
    },
    'apple-spas': {
      history: `Apple Spas is a popular name for the Feast of the Transfiguration on 19 August in parts of Eastern Europe. Apples and other fruit are blessed as late summer begins to turn toward autumn.`,
      tradition: `Fruit may be carried to church, shared with family and neighbours, or given in memory of the dead. Regional rules about when the season's apples are first eaten reflect local custom rather than one universal doctrine.`,
      steps: ['Choose a local seasonal fruit.', 'Cut it and notice seed, scent, colour and ripeness.', 'Share a portion or donate fresh food.', 'Write what has ripened and what must now change.'],
      note: `The folk name and domestic customs sit within a Christian feast; practices vary across countries and parishes.`,
      sources: [researchSources.appleSpas]
    },
    'veles-night': {
      history: `“Veles Night” on 31 October is best understood as a modern Slavic Native Faith or Slavic-inspired observance. Evidence does not support describing it as one universally attested ancient pan-Slavic festival fixed to this date.`,
      tradition: `Contemporary practitioners may use the night for ancestor remembrance, dreams and symbolism connected with Veles. Clear labelling protects the distinction between documented folklore, modern reconstruction and personal spiritual practice.`,
      steps: ['Choose one verified family name, story or object.', 'Light a candle in a safe holder and offer gratitude.', 'Write the inherited quality you wish to continue.', 'Close deliberately: extinguish the candle, wash your hands and return to ordinary activity.'],
      note: `This calendar names the observance as modern; it should not be cited as proof of a single ancient Slavic Halloween.`,
      sources: [researchSources.slavicFaith]
    },
    'dziady': {
      history: `Dziady (“forefathers”) refers to ancestor-remembrance customs known in parts of Poland, Belarus, Lithuania and neighbouring regions. Practices changed across place and time and became widely known through Adam Mickiewicz's nineteenth-century dramatic cycle.`,
      tradition: `Food, drink, fire, names and hospitality could mediate remembrance of the dead. Contemporary observance ranges from family memorial practice to literary, folkloric and reconstructed ritual forms.`,
      steps: ['Research one ancestor or predecessor using a reliable family source.', 'Set out a name, photograph or neutral object.', 'Offer gratitude without claiming supernatural certainty.', 'Preserve one story in writing for someone younger.'],
      note: `Do not combine distinct regional customs into a single definitive rite; family and community context matters.`,
      sources: [researchSources.dziadyStudy, researchSources.dziady]
    }
  };

  const zodiacResearch = {
    aquarius: ['Aquarius', 'water-bearer imagery, collective thinking and intellectual independence', 'Compare one unconventional idea with the needs of the wider community.'],
    pisces: ['Pisces', 'two fish, permeability, imagination and compassion', 'Give a dream or intuition a concrete boundary and a practical next step.'],
    aries: ['Aries', 'the ram, initiative, contest and directness', 'Begin one task before enthusiasm turns into impatience.'],
    taurus: ['Taurus', 'the bull, embodiment, value and endurance', 'Improve one material support: food, budget, rest, tools or surroundings.'],
    gemini: ['Gemini', 'the twins, exchange, language and multiplicity', 'Ask a better question and listen for an answer that changes your view.'],
    cancer: ['Cancer', 'the crab, shelter, kinship and emotional memory', 'Strengthen one boundary that makes care more sustainable.'],
    leo: ['Leo', 'the lion, visibility, sovereignty and creative warmth', 'Share one finished piece of work instead of waiting for perfection.'],
    virgo: ['Virgo', 'the maiden, harvest, discernment and skilled service', 'Repair one system that would make daily care more reliable.'],
    libra: ['Libra', 'the scales, proportion, justice and reciprocity', 'Name what a fair exchange would require from every person involved.'],
    scorpio: ['Scorpio', 'the scorpion, secrecy, intensity and transformation', 'Tell yourself one difficult truth without turning it into self-punishment.'],
    sagittarius: ['Sagittarius', 'the archer, direction, travel and the search for meaning', 'Choose a horizon and identify the first disciplined step toward it.'],
    capricorn: ['Capricorn', 'the sea-goat, structure, responsibility and long-range achievement', 'Turn one ambition into a milestone, deadline and repeatable routine.']
  };

  Object.entries(zodiacResearch).forEach(([key, [name, symbols, action]]) => {
    researchProfiles[key] = {
      history: `${name} is one of the twelve signs of the Greco-Roman zodiac, a system whose constellations, images and astrological meanings developed through long exchanges among Mesopotamian, Egyptian, Greek and later European traditions. The tropical zodiac used by most Western astrologers divides the ecliptic into twelve equal signs; it is not identical to today's astronomical constellations.`,
      tradition: `In modern astrology, ${name} is read through ${symbols}. These are symbolic associations used for reflection and interpretation, not scientifically established forces or personality diagnoses.`,
      steps: ['Read the season theme as a question, not a verdict.', action, 'Notice evidence that complicates the symbolism.', 'Keep what is useful and leave what is not.'],
      note: `Astrology is a cultural and symbolic tradition, not a scientific method for predicting events or defining a person.`,
      sources: [researchSources.zodiacOxford, researchSources.zodiacBerlin]
    };
  });

  const monthSelect = root.querySelector('[data-calendar-month]');
  const yearSelect = root.querySelector('[data-calendar-year]');
  const grid = root.querySelector('[data-calendar-grid]');
  const detailKicker = root.querySelector('[data-calendar-details-kicker]');
  const detailTitle = root.querySelector('[data-calendar-details-title]');
  const signature = root.querySelector('[data-calendar-signature]');
  const detailContent = root.querySelector('[data-calendar-details-content]');
  const timeline = root.querySelector('[data-calendar-timeline]');
  const monthVisualLabel = root.querySelector('[data-month-visual-label]');
  const monthVisual = root.querySelector('.grc__month-visual');
  const calendarStatus = root.querySelector('[data-calendar-status]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let renderedPeriod = '';
  let monthAnimation;
  const filters = [...root.querySelectorAll('[data-filter]')];
  const imageData = root.querySelector('[data-calendar-images]');
  const eventImageData = root.querySelector('[data-calendar-event-images]');
  const countdown = root.querySelector('[data-calendar-countdown]');
  const countdownTitle = root.querySelector('[data-countdown-title]');
  const countdownDate = root.querySelector('[data-countdown-date]');
  const countdownDays = root.querySelector('[data-countdown-days]');
  const countdownHours = root.querySelector('[data-countdown-hours]');
  const countdownMinutes = root.querySelector('[data-countdown-minutes]');
  const countdownSeconds = root.querySelector('[data-countdown-seconds]');
  const countdownOpen = root.querySelector('[data-countdown-open]');
  let monthImages = Array.isArray(window.WHISPERS_MONTH_ART) ? window.WHISPERS_MONTH_ART : [];
  if (!monthImages.length) {
    try { monthImages = JSON.parse(imageData?.textContent || '[]'); } catch (error) { monthImages = []; }
  }
  let eventImages = {};
  try { eventImages = JSON.parse(eventImageData?.textContent || '{}'); } catch (error) { eventImages = {}; }
  const now = new Date();
  const params = new URLSearchParams(window.location.search);
  let month = clamp(Number(params.get('month') || now.getMonth() + 1) - 1, 0, 11);
  let year = clamp(Number(params.get('year') || now.getFullYear()), 2020, 2045);
  let selectedDay = clamp(Number(params.get('day') || 0), 0, 31);
  let activeFilter = 'all';
  let eventMap = new Map();
  let dayCells = new Map();
  let nextEvent = null;
  let countdownTimer = null;

  months.forEach((name, index) => monthSelect.add(new Option(name, index)));
  for (let value = 2020; value <= 2045; value += 1) yearSelect.add(new Option(value, value));

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, Number.isFinite(value) ? value : min));
  }

  function escapeHtml(value) {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function dayKey(eventMonth, day) {
    return `${eventMonth}-${day}`;
  }

  // Calendar days and astronomical instants use the same visitor timezone.
  const calendarZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  const clockFormat = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hourCycle: 'h23', timeZone: calendarZone, timeZoneName: 'shortOffset' });
  const zoneNote = root.querySelector('[data-calendar-timezone]');
  if (zoneNote) zoneNote.textContent = `Times shown in your timezone: ${calendarZone}. ${Array.isArray(window.WoteMoonTimes?.events) ? 'Lunar phases: US Naval Observatory, minute precision.' : 'Published lunar timings unavailable; calculated times or estimated dates are marked.'} Other astronomical times are calculated. Traditional observances have no fixed time.`;

  function eventTiming(event) {
    if (!Number.isFinite(event.instant)) return '';
    // Round rather than truncate seconds when presenting minute precision.
    const date = new Date(Math.round(event.instant / 60000) * 60000);
    const label = event.timeKind === 'eclipse' ? 'Calculated global eclipse peak' : event.timeKind === 'season' ? 'Calculated equinox / solstice' : event.timeSource === 'USNO' ? 'Exact phase' : 'Calculated phase (approx.)';
    return `${label} · ${clockFormat.format(date)} · ${calendarZone}`;
  }

  function eventTimeMarkup(event, compact = false) {
    const label = eventTiming(event);
    if (!label) return event.approximate ? '<span class="grc__event-time">Estimated date · exact time unavailable</span>' : '';
    const date = new Date(event.instant);
    const clock = clockFormat.format(new Date(Math.round(event.instant / 60000) * 60000));
    const content = compact === 'mobile' ? clock.split(' ')[0] : compact ? clock : label;
    return `<time class="grc__event-time" datetime="${date.toISOString()}" title="${escapeHtml(label)}">${escapeHtml(content)}</time>`;
  }

  function eventLabel(event) {
    const timing = eventTiming(event);
    return `${event.title}${timing ? ` · ${timing}` : event.approximate ? ' · estimated date' : ''}`;
  }

  function addEvent(map, eventMonth, day, event) {
    const key = dayKey(eventMonth, day);
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(event);
  }

  function eventImageKey(event) {
    const title = event.title || '';
    if (/Blue Moon/i.test(title)) return 'blue-moon';
    if (/Black Moon/i.test(title)) return 'black-moon';
    if (/Lunar Eclipse/i.test(title)) return 'lunar-eclipse';
    if (/Solar Eclipse/i.test(title)) return 'solar-eclipse';
    if (/First Quarter Moon/i.test(title)) return 'first-quarter-moon';
    if (/Last Quarter Moon/i.test(title)) return 'last-quarter-moon';
    if (/New Moon/i.test(title)) return 'new-moon';
    if (/Full Moon/i.test(title)) return 'full-moon';
    const namedKeys = [
      'imbolc', 'ostara', 'beltane', 'litha', 'lughnasadh', 'mabon', 'samhain', 'yule',
      'kolyada', 'gromnica', 'zhavoronki', 'walpurgis', 'kupala', 'dziady',
      'aquarius', 'pisces', 'aries', 'taurus', 'gemini', 'cancer',
      'leo', 'virgo', 'libra', 'scorpio', 'sagittarius', 'capricorn'
    ];
    const normalized = title.toLowerCase();
    const named = namedKeys.find((key) => normalized.startsWith(key));
    if (named) return named;
    if (normalized.startsWith('honey spas')) return 'honey-spas';
    if (normalized.startsWith('apple spas')) return 'apple-spas';
    if (normalized.startsWith('veles night')) return 'veles-night';
    return '';
  }

  function eventImageFor(event) {
    return eventImages[eventImageKey(event)] || '';
  }

  function moonAge(date) {
    const synodicMonth = 29.530588853;
    const epoch = Date.UTC(2000, 0, 6, 18, 14);
    const days = (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 12) - epoch) / 86400000;
    return ((days % synodicMonth) + synodicMonth) % synodicMonth;
  }

  function moonGuideFor(date) {
    const age = moonAge(date);
    return moonGuides.find((guide) => age >= guide.range[0] && age < guide.range[1]) || moonGuides[0];
  }

  function buildMoonEvents(map) {
    const monthlyPhaseCounts = new Map();
    const addCalculatedPhase = (date, phase, precise = false, timeSource = '') => {
      const countKey = `${date.getMonth()}-${phase.title}`;
      const count = (monthlyPhaseCounts.get(countKey) || 0) + 1;
      monthlyPhaseCounts.set(countKey, count);
      let decoratedPhase = phase;
      if (phase.title === 'Full Moon' && count === 2) {
        decoratedPhase = {
          ...phase,
          title: 'Blue Moon · Second Full Moon',
          summary: 'This is the second Full Moon within one civil month, popularly called a Blue Moon. In modern witchcraft it is treated as an uncommon moment for culmination, rare opportunities and intentions that need exceptional emphasis.',
          meaning: 'A Blue Moon carries the symbolism of the Full Moon with an added sense of rarity. It favours acknowledging an unusual opening without forcing what is not ready.',
          correspondences: 'Moonlight, silver, deep blue, water, rare flowers, divination, culmination and exceptional opportunity.',
          prompt: 'Which rare opportunity deserves my full attention?'
        };
      }
      if (phase.title === 'New Moon' && count === 2) {
        decoratedPhase = {
          ...phase,
          title: 'Black Moon · Second New Moon',
          summary: 'This is the second New Moon within one civil month, popularly called a Black Moon. Modern witchcraft often associates it with deep renewal, private transformation and intentions that require silence before action.',
          meaning: 'A Black Moon intensifies the inward quality of the New Moon. It is suited to clearing old assumptions and planting a carefully protected intention.',
          correspondences: 'Darkness, black and indigo, still water, seeds, silence, cleansing, mystery and hidden beginnings.',
          prompt: 'What new beginning needs privacy before it can grow?'
        };
      }
      addEvent(map, date.getMonth(), date.getDate(), { ...decoratedPhase, type: 'moon', ...(precise ? { instant: date.getTime(), timeKind: 'phase', timeSource } : { approximate: true }) });
    };

    const publishedPhases = window.WoteMoonTimes?.events;
    if (Array.isArray(publishedPhases)) {
      const localYearPhases = publishedPhases.filter(([instant, quarter]) => Number.isFinite(instant) && Number.isInteger(quarter) && quarter >= 0 && quarter <= 3 && new Date(instant).getFullYear() === year).sort((a, b) => a[0] - b[0]);
      if (localYearPhases.length >= 48) {
        localYearPhases.forEach(([instant, quarter]) => addCalculatedPhase(new Date(instant), moonPhases[quarter], true, 'USNO'));
        return;
      }
    }

    if (window.Astronomy) {
      const start = new Date(year, 0, 1);
      const end = new Date(year + 1, 0, 1);
      let quarter = Astronomy.SearchMoonQuarter(new Date(start.getTime() - 8 * 86400000));
      while (quarter.time.date < end) {
        if (quarter.time.date >= start) {
          const phase = moonPhases[quarter.quarter];
          const date = quarter.time.date;
          addCalculatedPhase(date, phase, true);
        }
        quarter = Astronomy.NextMoonQuarter(quarter);
      }
      return;
    }

    const cycleMs = 29.530588853 * 86400000;
    const epoch = Date.UTC(2000, 0, 6, 18, 14);
    const start = Date.UTC(year, 0, 1);
    const end = Date.UTC(year + 1, 0, 1);
    const firstCycle = Math.floor((start - epoch) / cycleMs) - 1;
    const lastCycle = Math.ceil((end - epoch) / cycleMs) + 1;

    for (let cycle = firstCycle; cycle <= lastCycle; cycle += 1) {
      moonPhases.forEach((phase) => {
        const date = new Date(epoch + (cycle + phase.offset) * cycleMs);
        if (date.getFullYear() !== year) return;
        addCalculatedPhase(date, phase);
      });
    }
  }

  function buildEclipseEvents(map) {
    if (!window.Astronomy || !Astronomy.SearchLunarEclipse || !Astronomy.SearchGlobalSolarEclipse) return;
    const start = new Date(year, 0, 1);
    const end = new Date(year + 1, 0, 1);

    try {
      let lunar = Astronomy.SearchLunarEclipse(new Date(start.getTime() - 2 * 86400000));
      while (lunar.peak.date < end) {
        const date = lunar.peak.date;
        if (date >= start) {
          const kind = String(lunar.kind || 'lunar');
          const kindLabel = kind.charAt(0).toUpperCase() + kind.slice(1);
          addEvent(map, date.getMonth(), date.getDate(), {
            title: `${kindLabel} Lunar Eclipse`, type: 'moon', glyph: '◉', instant: date.getTime(), timeKind: 'eclipse',
            summary: `A ${kind.toLowerCase()} Lunar Eclipse intensifies the symbolism of the Full Moon. Modern witches often treat eclipses as thresholds for revelation, endings and unexpected course corrections.`,
            meaning: 'Eclipse work is less about forcing an outcome and more about observing what is exposed, staying grounded and allowing hidden information to surface.',
            correspondences: 'Shadow and light, black and silver, covered mirrors, water, protection, divination and release.',
            practice: 'Keep the practice simple. Ground yourself, record what becomes clear and postpone impulsive promises until the emotional atmosphere settles.',
            prompt: 'What is being revealed that I could not see before?',
            products: [['intuition', 'For insight during an intense threshold'], ['protection', 'For grounding and energetic boundaries']]
          });
        }
        lunar = Astronomy.NextLunarEclipse(lunar.peak);
      }

      let solar = Astronomy.SearchGlobalSolarEclipse(new Date(start.getTime() - 2 * 86400000));
      while (solar.peak.date < end) {
        const date = solar.peak.date;
        if (date >= start) {
          const kind = String(solar.kind || 'solar');
          const kindLabel = kind.charAt(0).toUpperCase() + kind.slice(1);
          addEvent(map, date.getMonth(), date.getDate(), {
            title: `${kindLabel} Solar Eclipse`, type: 'moon', glyph: '◉', instant: date.getTime(), timeKind: 'eclipse',
            summary: `A ${kind.toLowerCase()} Solar Eclipse joins the Sun and New Moon in a dramatic reset. In modern witchcraft it is commonly approached as a powerful, unpredictable threshold rather than an ordinary manifestation date.`,
            meaning: 'A solar eclipse can symbolise interruption, redirection and a new chapter whose meaning unfolds gradually.',
            correspondences: 'Darkened Sun, circles, gold and black, silence, protection, rest and new cycles.',
            practice: 'Observe safely without looking directly at the Sun. Keep ritual work protective and reflective, then write down what you are ready to reconsider.',
            prompt: 'Where might a pause reveal a more truthful direction?',
            products: [['protection', 'For grounding through a major shift'], ['custom', 'For a carefully chosen new chapter']]
          });
        }
        solar = Astronomy.NextGlobalSolarEclipse(solar.peak);
      }
    } catch (error) {
      console.warn('Eclipse data could not be calculated for this year.', error);
    }
  }

  function buildSeasonEvents(map) {
    if (!window.Astronomy) {
      seasons.forEach((event) => addEvent(map, event.month, event.day, event));
      return;
    }

    const exact = Astronomy.Seasons(year);
    seasons.forEach((event) => {
      let date = new Date(year, event.month, event.day, 12);
      if (event.title.startsWith('Ostara')) date = exact.mar_equinox.date;
      if (event.title.startsWith('Litha')) date = exact.jun_solstice.date;
      if (event.title.startsWith('Mabon')) date = exact.sep_equinox.date;
      if (event.title.startsWith('Yule')) date = exact.dec_solstice.date;
      const astronomical = /^(Ostara|Litha|Mabon|Yule)/.test(event.title);
      addEvent(map, date.getMonth(), date.getDate(), astronomical ? { ...event, instant: date.getTime(), timeKind: 'season' } : event);
    });
  }

  function buildEvents() {
    const map = new Map();
    buildMoonEvents(map);
    buildEclipseEvents(map);
    traditions.forEach((event) => addEvent(map, event.month, event.day, event));
    buildSeasonEvents(map);
    zodiac.forEach(([eventMonth, day, title, themes, productKey]) => {
      addEvent(map, eventMonth, day, {
        title,
        type: 'zodiac',
        glyph: '✧',
        summary: `The Sun enters a new zodiac season associated with ${themes.toLowerCase()}. In modern witchcraft and astrology, this ingress changes the symbolic atmosphere for approximately four weeks.`,
        meaning: 'A zodiac ingress is a thematic threshold rather than a single-day command. It invites us to notice which quality the coming weeks ask us to practise more consciously.',
        correspondences: `${themes}. Solar symbolism, seasonal observation and the element traditionally associated with the sign.`,
        practice: `Choose one grounded action that expresses ${themes.toLowerCase()} during the coming week.`,
        prompt: `Where could ${themes.toLowerCase()} become a lived practice?`,
        products: [[productKey, `Aligned with ${themes.toLowerCase()}`], ['tarot', 'For personal context and reflection']]
      });
    });
    return map;
  }

  function eventCandidatesFor(targetYear) {
    const previousYear = year;
    year = targetYear;
    const map = buildEvents();
    year = previousYear;
    const candidates = [];
    map.forEach((events, key) => {
      const [eventMonth, day] = key.split('-').map(Number);
      events.forEach(event => candidates.push({
        year: targetYear, month: eventMonth, day,
        exact: Number.isFinite(event.instant),
        date: Number.isFinite(event.instant) ? new Date(event.instant) : new Date(targetYear, eventMonth, day),
        expires: Number.isFinite(event.instant) ? event.instant : new Date(targetYear, eventMonth, day + 1).getTime(),
        events: [event]
      }));
    });
    return candidates;
  }

  function findNextEvent(referenceDate = new Date()) {
    const candidates = [referenceDate.getFullYear(), referenceDate.getFullYear() + 1]
      .filter((value) => value <= 2045)
      .flatMap(eventCandidatesFor)
      .filter((candidate) => candidate.expires > referenceDate.getTime())
      .sort((a, b) => a.date - b.date);
    if (!candidates.length) return null;
    const first = candidates[0];
    const sameDate = candidates.filter((candidate) => candidate.date.getTime() === first.date.getTime() && candidate.exact === first.exact);
    return {
      ...first,
      events: sameDate.flatMap((candidate) => candidate.events)
    };
  }

  function updateCountdown() {
    if (!countdown || !nextEvent) return;
    const current = new Date();
    const eventDay = nextEvent.date;
    if (current.getTime() >= nextEvent.expires) {
      nextEvent = findNextEvent(current);
      if (!nextEvent) {
        countdown.hidden = true;
        return;
      }
      return updateCountdown();
    }

    const remaining = Math.max(0, eventDay.getTime() - current.getTime());
    const days = Math.floor(remaining / 86400000);
    const hours = Math.floor((remaining % 86400000) / 3600000);
    const minutes = Math.floor((remaining % 3600000) / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);
    const titles = [...new Set(nextEvent.events.map((event) => event.title))];

    countdown.hidden = false;
    countdownTitle.textContent = titles.join(' · ');
    const dateLabel = new Intl.DateTimeFormat('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric', timeZone: calendarZone }).format(eventDay);
    countdownDate.textContent = nextEvent.exact
      ? `${dateLabel} · ${eventTiming(nextEvent.events[0])}`
      : `${remaining === 0 ? 'Observed today · ' : ''}${dateLabel} · No fixed time${nextEvent.events.some(event => event.approximate) ? ' (estimated date)' : ''}`;
    countdownDays.textContent = String(days).padStart(2, '0');
    countdownHours.textContent = String(hours).padStart(2, '0');
    countdownMinutes.textContent = String(minutes).padStart(2, '0');
    countdownSeconds.textContent = String(seconds).padStart(2, '0');
    countdown.setAttribute('aria-label', `${titles.join(' and ')} · ${countdownDate.textContent}`);
  }

  function startCountdown() {
    nextEvent = findNextEvent(new Date());
    updateCountdown();
    if (countdownTimer) window.clearInterval(countdownTimer);
    countdownTimer = window.setInterval(updateCountdown, 1000);
  }

  function visibleEvents(events) {
    return activeFilter === 'all' ? events : events.filter((event) => event.type === activeFilter);
  }

  function chooseProducts(events) {
    const choices = [];
    const source = events.flatMap((event) => event.products || []);
    source.forEach(([key, reason]) => {
      if (!productCatalog[key] || choices.some((choice) => choice.key === key) || choices.length >= 3) return;
      choices.push({ key, reason, ...productCatalog[key] });
    });
    return choices;
  }

  function eventBadges(events) {
    const badges = events.map((event) => `
      <span class="grc__event-badge">
        <i class="grc__dot grc__dot--${escapeHtml(event.type)}"></i>${escapeHtml(event.title)} ${eventTimeMarkup(event, true)}
      </span>`).join('');
    return `<div class="grc__event-badges">${badges}</div>`;
  }

  // Audited v2 artwork: [source width, source height, title/ornament top, bottom].
  // Fractions refer to the actual source, not its letterboxed thumbnail. The
  // Moon, seasonal and zodiac compositions do not share a common focal point.
  const eventArtworkProfiles = {
    'new-moon': [1254, 1254, .294, .415],
    'first-quarter-moon': [1254, 1254, .230, .352],
    'full-moon': [1254, 1254, .285, .462],
    'last-quarter-moon': [1254, 1254, .330, .504],
    'lunar-eclipse': [1254, 1254, .362, .497],
    'solar-eclipse': [1254, 1254, .357, .512],
    'blue-moon': [1254, 1254, .278, .445],
    'black-moon': [1254, 1254, .278, .555],
    imbolc: [1254, 1254, .182, .355],
    ostara: [1254, 1254, .176, .336],
    beltane: [1254, 1254, .200, .383],
    litha: [1254, 1254, .176, .342],
    lughnasadh: [1254, 1254, .203, .342],
    mabon: [1254, 1254, .179, .345],
    samhain: [1254, 1254, .176, .342],
    yule: [1254, 1254, .176, .330],
    kolyada: [1672, 941, .131, .354],
    gromnica: [1672, 941, .163, .373],
    zhavoronki: [1672, 941, .198, .386],
    walpurgis: [1672, 941, .124, .333],
    kupala: [1672, 941, .194, .409],
    'honey-spas': [1672, 941, .129, .366],
    'apple-spas': [1672, 941, .129, .360],
    'veles-night': [1672, 941, .150, .371],
    dziady: [1672, 941, .118, .339],
    aquarius: [1672, 941, .015, .214],
    pisces: [1672, 941, .038, .293],
    aries: [1672, 941, .027, .215],
    taurus: [1672, 941, .022, .231],
    gemini: [1672, 941, .061, .315],
    cancer: [1672, 941, .054, .312],
    leo: [1672, 941, .027, .263],
    virgo: [1672, 941, .043, .323],
    libra: [1672, 941, .043, .312],
    scorpio: [1672, 941, .029, .326],
    sagittarius: [1672, 941, .048, .253],
    capricorn: [1672, 941, .027, .265]
  };

  function calculateEventArtCrop(profile, width, baseHeight) {
    if (!profile || !Number.isFinite(width) || width <= 0 || !Number.isFinite(baseHeight) || baseHeight <= 0) return null;
    const [sourceWidth, sourceHeight, titleTop, titleBottom] = profile;
    // Retain the usual 180–230px banner. Only a title that cannot fit (notably
    // the two-line Black Moon at tablet widths) earns more room, never clipping.
    const bandHeight = (titleBottom - titleTop + .04) * sourceHeight * width / sourceWidth;
    const height = Math.max(baseHeight, Math.ceil(bandHeight + 20));
    const drawnHeight = sourceHeight * Math.max(width / sourceWidth, height / sourceHeight);
    const overflow = Math.max(0, drawnHeight - height);
    const desiredTop = (titleTop + titleBottom) / 2 * drawnHeight - height / 2;
    // Titles printed right at the source's top cannot be exactly centered
    // without inventing extra artwork. Keep the closest possible filled crop.
    const cropTop = Math.min(overflow, Math.max(0, desiredTop));
    return { height, position: overflow > .01 ? cropTop / overflow * 100 : 50 };
  }

  let clearEventArtwork = () => {};
  function syncEventArtwork() {
    clearEventArtwork();
    const images = [...detailContent.querySelectorAll('[data-event-art]')];
    const fit = (image) => {
      if (!detailContent.contains(image)) return;
      const crop = calculateEventArtCrop(eventArtworkProfiles[image.dataset.eventArt], image.getBoundingClientRect().width, Math.min(230, Math.max(180, window.innerWidth * .3)));
      if (!crop) return;
      const height = `${crop.height}px`, position = `center ${crop.position.toFixed(4)}%`;
      if (image.style.getPropertyValue('--event-art-height') !== height) image.style.setProperty('--event-art-height', height);
      if (image.style.getPropertyValue('--event-art-position') !== position) image.style.setProperty('--event-art-position', position);
    };
    const fitAll = () => images.forEach(fit);
    fitAll();
    if (typeof window.ResizeObserver === 'function') {
      const observer = new window.ResizeObserver((entries) => entries.forEach(({ target }) => fit(target)));
      images.forEach((image) => observer.observe(image));
      clearEventArtwork = () => observer.disconnect();
    } else {
      window.addEventListener('resize', fitAll, { passive: true });
      clearEventArtwork = () => window.removeEventListener('resize', fitAll);
    }
  }

  function researchDetails(event) {
    const profile = researchProfiles[eventImageKey(event)];
    if (!profile) return '';
    const steps = (profile.steps || []).map((step) => `<li>${escapeHtml(step)}</li>`).join('');
    const sources = (profile.sources || []).map(([label, url]) => `
      <li><a href="${escapeHtml(url)}" target="_blank" rel="noopener noreferrer">${escapeHtml(label)} ↗</a></li>`).join('');
    return `
      <section class="grc__research" aria-label="Researched background for ${escapeHtml(event.title)}">
        ${steps ? `<div class="grc__research-block grc__research-block--steps"><h4>If you would like to go further</h4><ol>${steps}</ol></div>` : ''}
        ${profile.note ? `<p class="grc__research-note"><strong>Research note:</strong> ${escapeHtml(profile.note)}</p>` : ''}
        <details class="grc__context">
          <summary>Background &amp; sources <span aria-hidden="true">+</span></summary>
          <div class="grc__context-body">
            <div class="grc__research-block">
              <h4>History &amp; context</h4>
              <p>${escapeHtml(profile.history)}</p>
            </div>
            <div class="grc__research-block">
              <h4>Tradition &amp; interpretation</h4>
              <p>${escapeHtml(profile.tradition)}</p>
            </div>
            ${sources ? `<div class="grc__sources"><strong>Further reading</strong><ul>${sources}</ul></div>` : ''}
          </div>
        </details>
      </section>`;
  }

  function eventLessons(events) {
    if (!events.length) return '';
    return `<div class="grc__event-lessons">${events.map((event) => `
      <article class="grc__event-lesson">
        ${eventImageFor(event) ? `<img class="grc__event-art" data-event-art="${escapeHtml(eventImageKey(event))}" src="${escapeHtml(eventImageFor(event))}" alt="Illustration for ${escapeHtml(event.title)}" loading="lazy">` : ''}
        <div class="grc__event-lesson-copy">
        <h3>${escapeHtml(event.title)}</h3>
        ${eventTimeMarkup(event)}
        ${event.timeKind === 'eclipse' ? '<p class="grc__time-note">This is the global peak, not a local start time. Visibility and local timings depend on your location.</p>' : ''}
        <section class="grc__at-glance" aria-label="${escapeHtml(event.title)} at a glance">
          <h4>At a glance</h4>
          <p>${escapeHtml(event.summary)}</p>
          <dl class="grc__correspondences">
            <div><dt>Symbolic meaning</dt><dd>${escapeHtml(event.meaning)}</dd></div>
            ${event.correspondences ? `<div><dt>Traditional correspondences</dt><dd>${escapeHtml(event.correspondences)}</dd></div>` : ''}
          </dl>
        </section>
        <section class="grc__practice" aria-label="A simple practice for ${escapeHtml(event.title)}">
          <h4>A simple practice</h4>
          <p>${escapeHtml(event.practice)}</p>
          <div class="grc__journal"><h5>A question for your journal</h5><p>${escapeHtml(event.prompt)}</p></div>
        </section>
        ${researchDetails(event)}
        </div>
      </article>`).join('')}</div>`;
  }

  function isFullCovenDate(events) {
    return events.some((event) =>
      event.type === 'season' ||
      (event.type === 'moon' && /New Moon|Full Moon|Eclipse/i.test(event.title)) ||
      (event.type === 'tradition' && /Kolyada|Walpurgis|Kupala|Veles Night|Dziady/i.test(event.title))
    );
  }

  function fullCovenCallout(events) {
    if (!isFullCovenDate(events)) return '';
    const alignments = events
      .filter((event) => isFullCovenDate([event]))
      .map((event) => event.title)
      .slice(0, 2)
      .join(' and ');
    return `
      <aside class="grc__coven-callout">
        <span class="grc__coven-mark" aria-hidden="true">✦</span>
        <span>
          <strong>Full Coven Ritual date</strong>
          <p>Our Full Coven Rituals are performed collectively on this key date${alignments ? `, in alignment with ${escapeHtml(alignments)}` : ''}. Full Coven is my most in-depth ritual, with stages aligned to the different lunar phases that suit your intention, a full report and extended guidance. Choose the spell that matches your intention; no specific outcome is promised.</p>
        </span>
      </aside>`;
  }

  function productCards(products) {
    return `
      <aside class="grc__products" aria-label="Recommended rituals">
        <div class="grc__products-header">
          <p>Chosen for this date</p>
          <h3>Ritual recommendations</h3>
        </div>
        <div class="grc__product-list">
          ${products.map((product) => `
            <a class="grc__product" href="/products/${escapeHtml(product.handle)}">
              <span class="grc__product-media"><img src="${escapeHtml(product.image)}" alt="" loading="lazy" width="132" height="132"></span>
              <span class="grc__product-copy">
                <span class="grc__product-title">${escapeHtml(product.title)}</span>
                <span class="grc__product-why">${escapeHtml(product.reason)}</span>
                <span class="grc__product-price">${product.price ? `${escapeHtml(product.price)} · ` : ''}Explore →</span>
              </span>
            </a>`).join('')}
        </div>
      </aside>`;
  }

  function showDetails(day, events, shouldScroll = false) {
    selectedDay = day;
    const filteredEvents = visibleEvents(events);
    if (!filteredEvents.length) return;
    const products = chooseProducts(filteredEvents);
    const intro = filteredEvents.length > 1
      ? `${filteredEvents.length} significant observances meet on this date. Explore each one below and choose the symbolism that speaks most clearly to your intention.`
      : '';

    detailKicker.textContent = 'Your guide to this date';
    detailTitle.textContent = `${months[month]} ${day}, ${year}`;
    signature.textContent = filteredEvents.map(eventLabel).join(' · ');
    detailContent.innerHTML = `
      <div class="grc__guide-body">
        <div class="grc__lesson">
          ${eventBadges(filteredEvents)}
          ${intro ? `<p class="grc__lesson-intro">${escapeHtml(intro)}</p>` : ''}
          ${fullCovenCallout(filteredEvents)}
          ${eventLessons(filteredEvents)}
          <aside class="grc__library-note"><small>From date to page</small><strong>Keep exploring at your own pace.</strong><a href="/pages/the-grimoire${filteredEvents.some((event) => event.type === 'moon') ? '?book=the-lunar-grimoire' : ''}">${filteredEvents.some((event) => event.type === 'moon') ? 'Open The Lunar Grimoire' : 'Browse The Library'} <span aria-hidden="true">↗</span></a></aside>
          <a class="grc__share-link" href="${shareUrl(day)}">Open a shareable link to this date →</a>
        </div>
        ${productCards(products)}
      </div>`;

    syncEventArtwork();
    updateAddress(day);
    const lunarTitle = filteredEvents.find(event => event.type === 'moon')?.title || '';
    const phase = /First Quarter/i.test(lunarTitle) ? 'first' : /Last Quarter/i.test(lunarTitle) ? 'last' : /New Moon|Black Moon/i.test(lunarTitle) ? 'new' : /Full Moon|Blue Moon/i.test(lunarTitle) ? 'full' : 'symbol';
    root.dispatchEvent(new CustomEvent('wote:calendar-date', { detail: { phase, glyph: filteredEvents[0].glyph, label: filteredEvents[0].title, image: eventImageFor(filteredEvents[0]), animate: shouldScroll } }));
    if (shouldScroll) {
      root.querySelector('[data-calendar-details]').scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
      detailTitle.focus({ preventScroll: true });
    }
  }

  function shareUrl(day) {
    const url = new URL(window.location.href);
    url.searchParams.set('month', month + 1);
    url.searchParams.set('year', year);
    url.searchParams.set('day', day);
    return url.pathname + url.search;
  }

  function updateAddress(day) {
    const url = new URL(window.location.href);
    url.searchParams.set('month', month + 1);
    url.searchParams.set('year', year);
    url.searchParams.set('day', day);
    window.history.replaceState({}, '', url);
  }

  function renderTimeline() {
    const items = [];
    eventMap.forEach((events, key) => {
      const [eventMonth, day] = key.split('-').map(Number);
      if (eventMonth !== month) return;
      visibleEvents(events).forEach((event) => items.push({ day, event }));
    });
    items.sort((a, b) => a.day - b.day);

    if (!items.length) {
      timeline.innerHTML = '<p class="grc__empty">No dates match this filter in the selected month. Choose “All” to see the full guide.</p>';
      return;
    }

    timeline.innerHTML = items.map(({ day, event }) => `
      <button type="button" class="grc__timeline-card" data-timeline-day="${day}">
        <span class="grc__timeline-date">${day}<small>${months[month].slice(0, 3)}</small></span>
        ${eventImageFor(event) ? `<img class="grc__timeline-art" src="${escapeHtml(eventImageFor(event))}" alt="" loading="lazy">` : ''}
        <span>
          <h3><i class="grc__dot grc__dot--${escapeHtml(event.type)}"></i> ${escapeHtml(event.title)}</h3>
          ${eventTimeMarkup(event)}
          <p>${escapeHtml(event.summary)}</p>
        </span>
      </button>`).join('');

    timeline.querySelectorAll('[data-timeline-day]').forEach((button) => {
      button.addEventListener('click', () => selectDay(Number(button.dataset.timelineDay), true));
    });
  }

  function selectDay(day, shouldScroll = false) {
    dayCells.forEach((cell) => cell.setAttribute('aria-pressed', 'false'));
    const cell = dayCells.get(day);
    if (cell) cell.setAttribute('aria-pressed', 'true');
    showDetails(day, eventMap.get(dayKey(month, day)) || [], shouldScroll);
  }

  function render() {
    const period = `${year}-${month}`;
    if (renderedPeriod && period !== renderedPeriod && !reducedMotion.matches && monthVisual?.animate) {
      monthAnimation?.cancel();
      monthAnimation = monthVisual.animate([{ opacity: .2 }, { opacity: 1 }], { duration: 420, easing: 'ease-out' });
    }
    renderedPeriod = period;
    if (calendarStatus) calendarStatus.textContent = `${months[month]} ${year}. ${activeFilter === 'all' ? 'All observances' : activeFilter + ' filter'} selected.`;
    if (monthImages[month]) root.style.setProperty('--grc-month-image', `url("${monthImages[month]}")`);
    if (monthVisualLabel) monthVisualLabel.textContent = `${months[month]} ${year}`;
    monthSelect.value = String(month);
    yearSelect.value = String(year);
    eventMap = buildEvents();
    dayCells = new Map();
    grid.replaceChildren();

    const firstWeekday = (new Date(year, month, 1).getDay() + 6) % 7;
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    for (let index = 0; index < firstWeekday; index += 1) {
      const blank = document.createElement('span');
      blank.className = 'grc__day grc__day--empty';
      blank.setAttribute('aria-hidden', 'true');
      grid.append(blank);
    }

    for (let day = 1; day <= daysInMonth; day += 1) {
      const allEvents = eventMap.get(dayKey(month, day)) || [];
      const dayEvents = visibleEvents(allEvents);
      const fullCovenDate = isFullCovenDate(dayEvents);
      const eventGlyph = dayEvents.find((event) => event.glyph)?.glyph || (dayEvents.length ? '✦' : '');
      const dayImage = dayEvents.length ? eventImageFor(dayEvents[0]) : '';
      const cell = document.createElement('button');
      cell.type = 'button';
      cell.className = 'grc__day';
      cell.style.setProperty('--grc-art-x', `${12 + ((day * 37) % 76)}%`);
      cell.style.setProperty('--grc-art-y', `${14 + ((day * 23) % 72)}%`);
      if (dayImage) cell.style.setProperty('--grc-day-image', `url("${dayImage}")`);
      cell.setAttribute('aria-label', `${months[month]} ${day}, ${year}${dayEvents.length ? `: ${dayEvents.map(eventLabel).join('; ')}${fullCovenDate ? '. Full Coven date' : ''}` : ', no key observance'}`);
      cell.setAttribute('aria-pressed', 'false');
      if (year === now.getFullYear() && month === now.getMonth() && day === now.getDate()) cell.classList.add('grc__day--today');
      if (dayEvents.length) cell.classList.add('grc__day--featured');
      if (!dayEvents.length) cell.classList.add('grc__day--quiet');
      if (fullCovenDate) cell.classList.add('grc__day--coven');
      cell.disabled = !dayEvents.length;
      cell.innerHTML = `
        <span class="grc__day-visual" aria-hidden="true">
          <span class="grc__date">${day}</span>
          ${eventGlyph ? `<span class="grc__moon-glyph">${escapeHtml(eventGlyph)}</span>` : ''}
          ${fullCovenDate ? '<span class="grc__coven-seal">Full Coven</span>' : ''}
        </span>
        ${dayEvents.some(event => Number.isFinite(event.instant)) ? `<span class="grc__mobile-times" aria-hidden="true">${dayEvents.filter(event => Number.isFinite(event.instant)).map(event => eventTimeMarkup(event, 'mobile')).join('')}</span>` : ''}
        ${dayEvents.length ? '<span class="grc__day-content"></span>' : ''}`;
      const dayContent = cell.querySelector('.grc__day-content');

      if (dayEvents.length) {
        const list = document.createElement('span');
        list.className = 'grc__day-events';
        dayEvents.slice(0, 2).forEach((event) => {
          const item = document.createElement('span');
          item.className = 'grc__day-event';
          item.innerHTML = `<i class="grc__dot grc__dot--${escapeHtml(event.type)}"></i><span>${escapeHtml(event.title)}${eventTimeMarkup(event, true)}</span>`;
          list.append(item);
        });
        if (dayEvents.length > 2) {
          const more = document.createElement('span');
          more.className = 'grc__day-more';
          more.textContent = `+${dayEvents.length - 2} more`;
          list.append(more);
        }
        dayContent.append(list);
      }

      if (dayEvents.length) {
        cell.addEventListener('click', () => selectDay(day, true));
        dayCells.set(day, cell);
      }
      grid.append(cell);
    }

    const visibleEventDays = [...eventMap.entries()]
      .map(([key, events]) => ({ parts: key.split('-').map(Number), events }))
      .filter(({ parts, events }) => parts[0] === month && visibleEvents(events).length)
      .map(({ parts }) => parts[1])
      .sort((a, b) => a - b)[0];
    const validSelectedDay = selectedDay >= 1 && selectedDay <= daysInMonth && visibleEvents(eventMap.get(dayKey(month, selectedDay)) || []).length;
    const preferredDay = validSelectedDay ? selectedDay : visibleEventDays;
    renderTimeline();
    if (preferredDay) {
      selectDay(preferredDay);
    } else {
      detailKicker.textContent = 'No matching key dates';
      detailTitle.textContent = `${months[month]} ${year}`;
      signature.textContent = '';
      detailContent.innerHTML = '<p class="grc__empty">No important observance matches this filter in the selected month.</p>';
      root.dispatchEvent(new CustomEvent('wote:calendar-date', { detail: { empty: true } }));
    }
  }

  function changeMonth(offset) {
    month += offset;
    if (month < 0) { month = 11; year -= 1; }
    if (month > 11) { month = 0; year += 1; }
    year = clamp(year, 2020, 2045);
    selectedDay = 0;
    render();
  }

  monthSelect.addEventListener('change', () => {
    month = Number(monthSelect.value);
    selectedDay = 0;
    render();
  });
  yearSelect.addEventListener('change', () => {
    year = Number(yearSelect.value);
    selectedDay = 0;
    render();
  });
  root.querySelector('[data-calendar-previous]').addEventListener('click', () => changeMonth(-1));
  root.querySelector('[data-calendar-next]').addEventListener('click', () => changeMonth(1));
  countdownOpen?.addEventListener('click', () => {
    if (!nextEvent) return;
    month = nextEvent.month;
    year = nextEvent.year;
    selectedDay = nextEvent.day;
    activeFilter = 'all';
    filters.forEach((item) => {
      const active = item.dataset.filter === 'all';
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    render();
    root.querySelector('.grc__shell').scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
  });
  filters.forEach((button) => {
    button.addEventListener('click', () => {
      activeFilter = button.dataset.filter;
      filters.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      render();
    });
  });

  render();
  startCountdown();
})();
